import { useTranslation } from 'react-i18next';
import { homeGroups as groups } from '@barter/shared';

interface CategoryPickerProps {
  /** Поточний id групи запчастин або '' */
  value: string;
  onChange: (id: string) => void;
}

/**
 * Вибір групи запчастин одним кроком: плитки 19 груп легкових +
 * «Шини, диски» й «Аксесуари» (сайт — вертикаль легкових запчастин).
 */
export function CategoryPicker({ value, onChange }: CategoryPickerProps) {
  const { t } = useTranslation();

  return (
    <div className="category-picker">
      <div className="category-picker__grid">
        {groups.map((cat) => (
          <button
            type="button"
            key={cat.id}
            className={`category-picker__tile${value === cat.id ? ' category-picker__tile--active' : ''}`}
            onClick={() => onChange(cat.id)}
          >
            <span className="category-picker__tile-icon">{cat.icon}</span>
            <span className="category-picker__tile-name">{t(cat.nameKey ?? cat.id)}</span>
          </button>
        ))}
      </div>
    </div>
  );
}
